import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'ru',
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns: ['common', 'home', 'rules', 'schedule', 'reserve', 'scoreboard', 'news'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
